import React, { useEffect, useState, useMemo } from "react";
import api from "../../axiosConfig";

const RecentActivityOne = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  // Formateador de fecha en español MX (zona local del navegador)
  const dateFormatter = useMemo(() => {
    try {
      return new Intl.DateTimeFormat("es-MX", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    } catch {
      return null;
    }
  }, []);

  const formatFecha = (iso) => {
    if (!iso) return "-";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return dateFormatter ? dateFormatter.format(d) : d.toLocaleString();
  };

  // 🔥 Normalizar el campo host
  const cleanHost = (host) => {
    if (!host) return "-";
    // Quitar prefijo /comondu/api/
    let cleaned = host.startsWith("/comondu/api/")
      ? host.replace("/comondu/api/", "")
      : host;
    // Reemplazar todas las / por espacio
    cleaned = cleaned.replace(/\//g, " ");
    return cleaned.trim();
  };

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      setLoading(true);
      setErr(null);
      try {
        const res = await api.get("/dashboard/admin/recientes");
        const list = Array.isArray(res?.data?.data) ? res.data.data : [];

        const normalized = list.map((it) => ({
          fecha: it.fecha ?? it.Fecha,
          tipo: it.tipo ?? it.Tipo,
          rfc: it.rfc ?? it.Rfc,
          nombre: it.nombre ?? it.Nombre,
          host: it.host ?? it.Host,
          idBitacora: it.idBitacora ?? it.id_bitacora ?? it.ID ?? it.id,
        }));

        if (mounted) setRows(normalized);
      } catch (e) {
        console.error("Error cargando recientes:", e);
        if (mounted) setErr("No se pudo cargar la actividad reciente.");
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="col-xxl-8">
      <div className="card h-100">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">
          <h6 className="text-lg fw-semibold mb-0">Actividad reciente</h6>
        </div>

        <div className="card-body p-0">
          {err && (
            <div className="alert alert-danger m-16" role="alert">
              {err}
            </div>
          )}

          <div className="table-responsive scroll-sm">
            <table className="table bordered-table mb-0 rounded-0 border-0">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>ID</th>
                  <th>Tipo</th>
                  <th>Host</th>
                  <th>Fecha</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  Array.from({ length: 5 }).map((_, i) => (
                    <tr key={`skeleton-${i}`}>
                      <td colSpan={5}>
                        <div className="placeholder-glow">
                          <span className="placeholder col-12"></span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : rows.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center text-secondary-light py-24">
                      Sin actividad reciente.
                    </td>
                  </tr>
                ) : (
                  rows.map((r, idx) => (
                    <tr key={r.idBitacora ?? idx}>
                      <td>
                        <div className="flex-grow-1">
                          <h6 className="text-md mb-0">{r.nombre || "-"}</h6>
                          <span className="text-sm text-secondary-light fw-medium">
                            {r.rfc || "-"}
                          </span>
                        </div>
                      </td>
                      <td>#{r.idBitacora ?? "-"}</td>
                      <td>
                        <span className="px-10 py-4 radius-8 fw-medium text-sm bg-neutral">
                          {r.tipo || "-"}
                        </span>
                      </td>
                      <td>{cleanHost(r.host)}</td>
                      <td>{formatFecha(r.fecha)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentActivityOne;